<template>
  <div class="featured-collection" :style="[paddingStyles, bgColorStyles]">
    <div
      class="featured-collection__carousel"
      :class="{'featured-collection__carousel--hover': hovered}"
    >
      <div class="controls-container">
        <div class="featured-collection__header">
          <h4 :class="featuredCollection.headingColor">{{featuredCollection.heading}}</h4>
        </div>
        <div class="featured-collection__subheader">
          {{featuredCollection.subHeading}}
        </div>
        <div class="featured-skin-slider-container">
          <tabs class="featured-skin-slider-tabs">

            <!-- Shop By Skin Concern -->
            <tab  title="SHOP BY SKIN CONCERN" active="true">
               <div class="arrows" v-if="!enableArrowHiding">
                <arrow-button
                  primary
                  left
                  @click="slidePrev('skinconcern')"
                  label="Product Navigation Previous"
                  class="button--arrow-primary button--left"
                  :disabled="leftArrowDisabled"
                />
                <arrow-button
                  primary
                  right
                  @click="slideNext('skinconcern')"
                  label="Product Navigation Next"
                  class="button--arrow-primary button--right"
                  :disabled="rightArrowDisabled"
                />
              </div>
              <swiper
                :options="carouselOptions"
                ref="SkinConcernImageCarousel"
                :class="{ 'swiper-no-swiping' : !shouldSwipe }"
              >
                <swiper-slide
                  v-for="(skinType, index) in featuredCollection.shop_by_skin_concern"
                  :key="`skinType-${index}`"
                >
                  <div @mouseover="hovered = true" @mouseleave="hovered = false">
                    <v-link :href="skinType.shop_by_skin_concern_url">
                      <img
                        class="product-tile__img-main"
                        :src="skinType.shop_by_concern_image"
                        :alt="skinType.shop_by_concern_title"
                        />
                    </v-link>

                  </div>
                </swiper-slide>
              </swiper>
            </tab>

            <!-- Shop By Skin Type -->
            <tab  title="SHOP BY SKIN TYPE" id="skintype" >
              <div class="arrows" v-if="!enableArrowHiding">
                <arrow-button
                  primary
                  left
                  @click="slidePrev('skintype')"
                  label="Product Navigation Previous"
                  class="button--arrow-primary button--left"
                  :disabled="leftArrowDisabled"
                />
                <arrow-button
                  primary
                  right
                  @click="slideNext('skintype')"
                  label="Product Navigation Next"
                  class="button--arrow-primary button--right"
                  :disabled="rightArrowDisabled"
                />
              </div>
              <swiper
                :options="carouselOptions"
                ref="skinTypeImageCarousel"
                :class="{ 'swiper-no-swiping' : !shouldSwipe }"
              >
                <swiper-slide
                  v-for="(skinType, index) in featuredCollection.shop_by_skin_type"
                  :key="`skinType-${index}`"
                >
                  <v-link :href="skinType.shop_by_skin_type_url">
                    <img
                    class="product-tile__img-main"
                    :src="skinType.shop_by_skin_type_image"
                    :alt="skinType.shop_by_skin_type_title"
                    />
                  </v-link>
                </swiper-slide>
              </swiper>
            </tab>

            <!-- Shop By Product Type -->
            <tab  title="SHOP BY PRODUCT TYPE">
              <div class="arrows" v-if="!enableArrowHiding">
                <arrow-button
                  primary
                  left
                  @click="slidePrev('producttype')"
                  label="Product Navigation Previous"
                  class="button--arrow-primary button--left"
                  :disabled="leftArrowDisabled"
                />
                <arrow-button
                  primary
                  right
                  @click="slideNext('producttype')"
                  label="Product Navigation Next"
                  class="button--arrow-primary button--right"
                  :disabled="rightArrowDisabled"
                />
              </div>
              <swiper
                :options="carouselOptions"
                ref="ProductTypeImageCarousel"
                :class="{ 'swiper-no-swiping' : !shouldSwipe }"
              >
                <swiper-slide
                  v-for="(skinType, index) in featuredCollection.shop_by_product_type"
                  :key="`skinType-${index}`"
                >
                  <div @mouseover="hovered = true" @mouseleave="hovered = false">
                    <v-link :href="skinType.shop_by_product_type_url">
                      <img
                      class="product-tile__img-main"
                      :src="skinType.shop_by_product_type_image"
                      :alt="skinType.shop_by_product_type_title"
                      />
                    </v-link>
                  </div>
                </swiper-slide>
              </swiper>
            </tab>

          </tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon.vue';
import ProductTile from '@/scripts/components/product/ProductTile.vue';
import css from 'swiper/swiper-bundle.min.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import VButton from '@/scripts/components/buttons/VButton.vue';
import VLink from '@/scripts/components/buttons/VLink.vue';
import ArrowButton from '@/scripts/components/buttons/ArrowButton.vue'
import { isHiddenProduct, checkUndefined } from '@/scripts/helpers/util';
import { px } from '@/scripts/filters/string.js';
import { Tabs, Tab } from 'vue-simple-tabs'



const cssVars = require('@/styles/variables.scss');

export default {
  name: 'FeaturedSkinSlider',
  components: {
    swiper,
    swiperSlide,
    Icon,
    VButton,
    VLink,
    ArrowButton,
    Tabs,
    Tab
  },
  props: {
    productTileTextAlignment: String,
    featuredCollection: {
      type: Object,
      default: () => ({
        heading: {
          type: String,
          required: true,
        }
      }),
    },
    enableArrowHiding: {
      type: Boolean,
      default: false,
    },
    enableSimpleTile: {
      type: Boolean,
      required: true,
    },
    enableSimpleTileCta: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      MAX_PRODUCTS_FOR_ARROWS: 5,
      slidesPerView: {
        hd: '3.282',
        desktop: '3.282',
        tablet: '3.282',
        mobile: '1.8665',
      },
      hovered: false,
      leftArrowDisabled: true,
      setLeftArrowDisabled: (isDisabled) => {
        return this.leftArrowDisabled = isDisabled;
      },
      rightArrowDisabled: false,
      setRightArrowDisabled: (isDisabled) => {
        return this.rightArrowDisabled = isDisabled;
      }
    };
  },
  computed: {
    bgColorStyles () {
      return {
        background: this.featuredCollection.bgColor
      }
    },
    swiperBySkinType() {
      return this.$refs.skinTypeImageCarousel.swiper;
    },
    swiperBySkinConcern() {
      return this.$refs.SkinConcernImageCarousel.swiper;
    },
    swiperByProductType() {
      return this.$refs.ProductTypeImageCarousel.swiper;
    },
    carouselOptions() {
      const setLeftDisabled = this.setLeftArrowDisabled;
      const setRightDisabled = this.setRightArrowDisabled;
      return {
        slidesPerView: 'auto',
        threshold: 5,
        loop: false,
        speed: 1000,
        on: {
          slideChange: function () {
            if (this.params.slidesPerView) {
              // Get length of array of non duplicate slides
              const numOfSlides = Array.from(this.slides).filter(
                (el) => !el.matches('.swiper-slide-duplicate')
              ).length;
              // if swiper is near the last slide the right arrow should be disabled
              // - 1 because last slide will go out of view otherwise
              if (this.realIndex >= numOfSlides - 1) {
                setRightDisabled(true);
              // when swiper is on the first slide the left arrow should be disabled
              } else if (this.realIndex <= 0) {
                setLeftDisabled(true);
              // else nothing should be disabled
              } else {
                setLeftDisabled(false);
                setRightDisabled(false);
              }
            }
          },
        },
      };
    },
    shouldSwipe() {
      return (
        this.slidesPerView[this.$mq] < 8
      );
    },
    paddingStyles() {
      return {
        'padding-top': px(
          checkUndefined(this.featuredCollection.marginTop, 56)
        ),
        'padding-bottom': px(
          checkUndefined(this.featuredCollection.marginBottom, 56)
        ),
      };
    },
  },
  methods: {
    filterProducts(products) {
      return products.filter(
        (prod) => prod.available && !isHiddenProduct(prod)
      );
    },
    slidePrev(type) {
      if (this.shouldSwipe) {
        if(type === 'skintype') {
          this.swiperBySkinType.slidePrev();
        }else if (type === 'skinconcern') {
          this.swiperBySkinConcern.slidePrev();
        }else if (type === 'producttype') {
          this.swiperByProductType.slidePrev();
        }
      }
    },
    slideNext(type) {
      if (this.shouldSwipe) {
        if(type === 'skintype') {
          this.swiperBySkinType.slideNext();
        }else if (type === 'skinconcern') {
          this.swiperBySkinConcern.slideNext();
        }else if (type === 'producttype') {
          this.swiperByProductType.slideNext();
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.featured-collection {
  overflow-clip-box: padding-box;
  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0px;
    @include mobile-only {
      margin-bottom: 16px;
    }

    h4 {
      line-height: rem(34);
      @include tablet-up {
        font-size: rem(40);
        line-height: rem(48);
      }
    }
  }
  &__subheader {
    margin-bottom: 0px;
    text-align: center;
  }
  .controls-container {
    max-width: 1100px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: -40px;
    position: relative;
    z-index: 2;
    width: 100%;
    @include mobile-only {
      width: 95%;
    }
    .arrows {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      width: fit-content;
      margin-bottom: -14px;
      padding-left: 20px;
      position: relative;
      z-index: 2;

      *:first-child {
        margin-right: 16px;
      }
      @include mobile-only {
        display: none;
      }
    }
  }
}
.featured-collection__carousel .swiper-container {
  padding-bottom: 10px;

  @include tablet-up {
    padding-bottom: 32px;
  }

  @include mobile-only {
      padding-top: 20px;
  }

  .template-index &,
  .template-product & {
    @include tablet-up {
      padding-bottom: 70px;
    }
  }
}


.featured-collection__carousel {
  position: relative;
  z-index: 3;

  @include tablet-up {
    margin-bottom: 0;
    padding-bottom: 0;
  }
}

.featured-collection__carousel--hover {
  z-index: 5;
}

.arrows:focus,
.arrows:hover {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}

/deep/ .swiper-container {
  z-index: auto;

  @include desktop-up {
    padding-bottom: 4px;
  }
}

/deep/ .swiper-wrapper {
  align-items: stretch;
}

/deep/ .swiper-slide {
  padding-left: 2px;
  padding-right: 2px;
  height: auto;
  background-color: #FFFFFF;
  width: 205px;
  @include tablet-up {
    padding-left: 4px;
    padding-right: 4px;
    width: 218px;
    margin: 0px 0;
  }
}

.swiper-slide-duplicate {
  opacity: 0;
  visibility: hidden;
}

.expert__feature-collection .swiper-container {
  @include tablet-up {
    padding-left: 236px;
  }
}

  .featured-skin-slider-tabs {
    margin-top: 20px;
    width: 100%;
    /deep/ ul {
      display: flex;
      justify-content: center;
      padding: 0;
      margin: 0;
    }
    /deep/ li {
      cursor: pointer;
      position: relative;
      font-family: $font-family-primary;
      font-size: rem(12);
      line-height: rem(14);
      padding-bottom: 15px;
      text-align: center;
      display: flex;
      align-items: flex-end;
      padding-left: 10px;
      padding-right: 10px;

      @include tablet-up {
        font-size: rem(14);
        line-height: rem(20);
        padding-left: 14px;
        padding-right: 14px;
      }

      &::after {
        content: ' ';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: #DDDCDA;
        transition: transform 300ms ease, background-color 300ms ease;
      }
      &:nth-child(2) {
        padding-left: 10px;
        padding-right: 10px;

        @include tablet-up {
          padding-left: 14px;
          padding-right: 14px;
        }
      }
      &:nth-child(3) {
        padding-left: 10px;
        padding-right: 10px;

        @include tablet-up {
          padding-left: 14px;
          padding-right: 14px;
        }
      }
      &.active {
        color: $color-black-900;

        &::after {
          background-color: $color-black-900;
        }
      }
    }
  }
</style>
